/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex Team runs Monte Carlo simulations across all 697,680 valid 5-driver, 2-constructor combinations and ranks them by projected points, respecting your $100M budget and any picks you lock in. It returns the top lineups in seconds — no manual spreadsheet work, no missed combinations.`)
};

const es_f1_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex Team ejecuta simulaciones Monte Carlo sobre las 697.680 combinaciones válidas de 5 pilotos y 2 constructores, y las clasifica por puntos previstos, respetando tu presupuesto de $100M y los picks que bloquees. Devuelve las mejores alineaciones en segundos — sin trabajo manual en hojas de cálculo, sin combinaciones que se te escapen.`)
};

const de_f1_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex-Team führt Monte-Carlo-Simulationen über alle 697.680 gültigen Kombinationen aus 5 Fahrern und 2 Konstrukteuren durch und sortiert sie nach prognostizierten Punkten, unter Berücksichtigung deines $100M-Budgets und aller gesperrten Picks. Es liefert die besten Teams in Sekunden — keine manuelle Tabellenkalkulation, keine übersehenen Kombinationen.`)
};

const nl_f1_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex Team draait Monte Carlo-simulaties over alle 697.680 geldige combinaties van 5 coureurs en 2 constructeurs en rangschikt ze op verwachte punten, met inachtneming van je budget van $100M en eventuele picks die je vergrendelt. Binnen enkele seconden krijg je de beste opstellingen — geen handmatig spreadsheetwerk, geen gemiste combinaties.`)
};

const fr_f1_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipe Apex exécute des simulations Monte Carlo sur les 697 680 combinaisons valides de 5 pilotes et 2 constructeurs, et les classe par points prédits, en respectant votre budget de 100 M$ et les choix que vous verrouillez. Il renvoie les meilleures compositions en quelques secondes — aucun travail manuel dans un tableur, aucune combinaison manquée.`)
};

const it_f1_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Apex esegue simulazioni Monte Carlo su tutte le 697.680 combinazioni valide di 5 piloti e 2 costruttori e le classifica per punti previsti, rispettando il tuo budget di $100M e le eventuali scelte bloccate. Restituisce le migliori formazioni in pochi secondi — niente calcoli manuali su foglio di calcolo, nessuna combinazione trascurata.`)
};

const pt_br2_f1_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Equipe Apex roda simulações Monte Carlo em todas as 697.680 combinações válidas de 5 pilotos e 2 construtores e as classifica por pontos previstos, respeitando seu orçamento de $100M e quaisquer escolhas que você fixar. Ela retorna as melhores escalações em segundos — sem trabalho manual em planilha, sem combinações perdidas.`)
};

const pt_f1_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Apex Team executa simulações de Monte Carlo em todas as 697.680 combinações válidas de 5 pilotos e 2 construtores e ordena-as por pontos previstos, respeitando o seu orçamento de $100M e quaisquer escolhas que bloqueie. Devolve as melhores formações em segundos — sem trabalho manual em folhas de cálculo, sem combinações por descobrir.`)
};

const ja_f1_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apexチームは、5ドライバー・2コンストラクターの有効な組み合わせ697,680通りすべてに対してモンテカルロシミュレーションを実行し、$100Mの予算とロック済みのピックを尊重しながら予測ポイントでランク付けします。上位のラインナップを数秒で返すため、手作業でのスプレッドシート作業も組み合わせの見落としも不要です。`)
};

const zh_f1_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex Team 对全部 697,680 种有效的 5 车手、2 车队组合运行蒙特卡罗模拟，并按预测积分排名，同时遵守你的 $100M 预算和任何锁定的选择。它在几秒内返回最佳阵容——无需手动做电子表格，也不会漏掉任何组合。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_faq1_a", locale)
	if (locale === "en") return en_f1_faq1_a(inputs)
	if (locale === "es") return es_f1_faq1_a(inputs)
	if (locale === "de") return de_f1_faq1_a(inputs)
	if (locale === "nl") return nl_f1_faq1_a(inputs)
	if (locale === "fr") return fr_f1_faq1_a(inputs)
	if (locale === "it") return it_f1_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_f1_faq1_a(inputs)
	if (locale === "pt") return pt_f1_faq1_a(inputs)
	if (locale === "ja") return ja_f1_faq1_a(inputs)
	return zh_f1_faq1_a(inputs)
};